import { FaFilePdf, FaFileZipper } from 'react-icons/fa6';

interface FileIconProps {
  mimeType?: string;
}

export function FileIcon({ mimeType }: FileIconProps) {
  if (mimeType === 'application/pdf') {
    return <FaFilePdf className="size-8 text-gray-500 dark:text-zinc-400 ms-2" />;
  }
  if (mimeType === 'application/zip') {
    return <FaFileZipper className="size-8 text-gray-500 dark:text-zinc-400 ms-2" />;
  }
  return null;
}
